import Box from "@mui/material/Box";
import { AddButton } from "app/components/Button/AddButton";
import BreadCrumb from "app/components/BreadCrumb";
import { ScrollableView } from "app/components/ScrollableView";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "utils/redux-injectors";

import AddTireTypeModal from "./components/AddTireTypeModal";
import TireTypeTable from "./components/TireTypeTable";
import {
  selectTireTypeList,
  selectTireTypeLoading,
  selectTireTypeMeta,
} from "./redux/selector";
import tireTypeSaga from "./redux/saga";
import { tireTypeActions, reducer, sliceKey } from "./redux/slice";
import { useStyles } from "./styles";

const TireType = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();
  const dispatch = useDispatch();

  useInjectReducer({
    key: sliceKey,
    reducer,
  });

  useInjectSaga({
    key: sliceKey,
    saga: tireTypeSaga,
  });

  const rows = useSelector(selectTireTypeList);
  const loading = useSelector(selectTireTypeLoading);
  const meta = useSelector(selectTireTypeMeta);

  useEffect(() => {
    dispatch(tireTypeActions.getTireTypeList());
  }, [dispatch]);

  const hasMoreItems = meta.currentPage < meta.totalPages;

  const getNextPage = () => {
    if (!loading && hasMoreItems) {
      dispatch(tireTypeActions.getNextPageItems());
    }
  };

  return (
    <Box className={styles.container}>
      <Box className={styles.scrollContent} dir={i18n.dir()}>
        <Box className={styles.pageContent}>
          <BreadCrumb title={t("SIDEBAR.TIRE_TYPE")} iconPosition="end" />
          <Box dir="ltr">
            <AddButton
              label={t("TIRE_TYPE.ACTIONS.ADD")}
              onClick={() => dispatch(tireTypeActions.openAddModal())}
            />
          </Box>
          <Box className={styles.tableContainer}>
            <ScrollableView
              borderless
              height="calc(100vh - 200px)"
              loadMore={getNextPage}
              hasMoreItems={hasMoreItems}
            >
              <TireTypeTable rows={rows} loading={loading} />
            </ScrollableView>
          </Box>
        </Box>
      </Box>
      <AddTireTypeModal />
    </Box>
  );
};

export default TireType;
